import fetch from "../fetch";

export default ({ params = {} } = {}) =>
  fetch({ path: "/common/north-american-states", params });
